import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { UpChatApiIntegrationService, UpChatLibModule } from '@unifiedpractice/up-chat-lib';
import { ChatApiIntegrationService } from './chat-api-integration.service';
import { ChatComponent } from './chat.component';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { StartupService } from '../core/services';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    TranslateModule,
    UpChatLibModule.forRoot({
      apiKey: '',
      service: {
        provide: UpChatApiIntegrationService,
        useClass: ChatApiIntegrationService,
      },
    }),
  ],
  declarations: [ChatComponent],
  exports: [UpChatLibModule],
  providers: [ChatApiIntegrationService],
})
export class ChatModule {
  constructor(private startupService: StartupService) {
    this.startupService.keyData.subscribe((config) => {
      if (config) {
        const apiKey = atob(config.streamChat);
        UpChatLibModule.forRoot({
          apiKey: apiKey,
          service: {
            provide: UpChatApiIntegrationService,
            useClass: ChatApiIntegrationService,
          },
        });
      }
    });
  }
}
